// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/solution'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 솔루션 등록 API
   * @param commit
   * @param payload // 여행지원서 유닛 번호 ex) this.$_payload('MemberSolutionPo',{'unitNo':1})
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async insertUserSolution ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/solution-uses`, payload)
  },

  /**
   * 유저 > 솔루션 > 유닛 리스트 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSolutionUnitList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/units`, payload)
  },


  /**
   * 유저 > 솔루션 > 솔루션 중지
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async pauseSolution ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/pause`, payload)
  },

  /**
   * 유저 > 솔루션 > 솔루션 중지 예약 취소
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async cancelStopSolution ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/cancelStop`, payload)
  },

  /**
   * 유저 > 솔루션 > 유닛 매핑여부 조회
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMappingSolution ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/mapping-yn`, payload)
  },
  /**
   * 솔루션 최종완료 확인 일자 업데이트
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateSltUseCmplt ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/slt-use-cmplt`, payload)
  }

}

export default { state, mutations, actions }
